import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './styles/globals.css';
import { initializeFirebase } from './config/firebase';

// Boot Firebase (and GA4 visitor analytics) on every page load — the app
// otherwise initializes lazily, which left analytics dormant on the landing page.
initializeFirebase();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
